// extracted by mini-css-extract-plugin
export var root = "_30ca8df0cfa455fd6165449804cc36ed-css";
export var list = "_8ba23eaa10628c50c57bd3f69a947f3c-css";
export var form = "_3770a5296fce73acea7a06b314b8ca32-css";